import intersection from 'lodash/intersection';

import { MOBILE_DEVICES } from 'shared/modules/page/constants';

export default (devices: string[]) =>
  intersection(devices, MOBILE_DEVICES).length > 0;
